import { useEffect, useMemo, useState } from "react";
import uiConfig from "../../uiConfig";
import { getCurrentSubdomain } from "../utils/subdomain";

/**
 * Loads account branding (name/logo) when visiting on a tenant subdomain.
 * Used pre-login (nav + login screen) so the tenant brand shows immediately.
 */
export default function useAccountBranding() {
  const serverUrl = uiConfig.serverInfo.serverUrl;
  const subdomain = useMemo(() => getCurrentSubdomain(), []);
  const [accountBranding, setAccountBranding] = useState(null);
  const [brandingLoading, setBrandingLoading] = useState(false);

  useEffect(() => {
    if (!subdomain) {
      setAccountBranding(null);
      return;
    }

    let cancelled = false;
    setBrandingLoading(true);

    fetch(`${serverUrl}/account/by-site?site_name=${encodeURIComponent(subdomain)}`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data?.success && data.account) {
          setAccountBranding({
            _id: data.account._id,
            full_name: data.account.full_name,
            site_name: data.account.site_name,
            logo_url: data.account.logo_url,
          });
        } else {
          setAccountBranding(null);
        }
      })
      .catch(() => {
        if (!cancelled) setAccountBranding(null);
      })
      .finally(() => {
        if (!cancelled) setBrandingLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [serverUrl, subdomain]);

  return { accountBranding, brandingLoading, subdomain };
}

